import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NavItemCodes} from '../../../../enums/nav-item-codes.enum';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {AnsweredQuestionRequest, AvailableQuestionnaire, FilledQuestionnaireRequest} from '../../../../models/questionnaire.model';
import {getValue, Store} from '@ngxs/store';
import {Observable, Subscription} from 'rxjs';
import {OfferCpi} from '../../../../models/offer.model';

@Component({
    selector: 'app-offer-questionnaire',
    templateUrl: './offer-questionnaire.component.html',
    styleUrls: ['./offer-questionnaire.component.less'],
})
export class OfferQuestionnaireComponent implements OnInit, OnDestroy {
    @Input() questionnaire: AvailableQuestionnaire;
    @Input() formPath: string;
    @Input() offer: OfferCpi;
    @Output() handleSubmit: EventEmitter<any> = new EventEmitter<any>();

    stateForm$: Observable<any>;
    formGroup: FormGroup;
    navItemCodes = NavItemCodes;
    errors: string[][] = [];
    subscription = new Subscription();

    constructor(private store: Store, private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.stateForm$ = this.store.select(state => getValue(state, this.formPath));
        this.subscription.add(
            this.stateForm$.subscribe(formState => {
                const errorMap = formState?.validationErrors ?? {};

                this.errors = this.questionnaire?.questions?.map((question, index) => {
                    const answerCodeErrors = errorMap?.[`answers[${index}].answerCode`]
                        || errorMap?.[`answers[${index}].answerVersion`]
                        || [];
                    const userInputErrors = errorMap?.[`answers[${index}].userInput`] || [];
                    return [...answerCodeErrors, ...userInputErrors];
                });
            })
        );
        this.setFormGroup();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    get formArray() {
        return this.formGroup?.controls?.questionnaire as FormArray;
    }

    setFormGroup() {
        this.formGroup = new FormGroup({
            questionnaire: new FormArray([])
        });
        this.questionnaire?.questions?.forEach((question) => {
            if (this.offer) {
                // populate form with saved questionnaire
                const filledQuestion = this.offer?.insuredProduct?.configuration?.questionnaire?.questions?.find((item) => {
                    return item?.code === question?.code;
                });
                const filledAnswer = filledQuestion?.answers?.find(answer => answer?.selected);
                const defaultAnswer = filledAnswer
                    ? question?.answers?.find(answer => answer?.code === filledAnswer?.code)
                    : null;
                this.formArray.push(new FormControl(defaultAnswer));
            } else {
                this.formArray.push(new FormControl(null));
            }
        });
        this.cdr.detectChanges();
    }

    getFormControl(index: number) {
        return this.formArray?.at(index) as FormControl;
    }

    onSubmit() {
        const answers = this.formArray?.value;
        const questions = this.questionnaire?.questions;
        const payload: FilledQuestionnaireRequest = new FilledQuestionnaireRequest({
            answers: questions.map((question, index) => {
                return new AnsweredQuestionRequest({
                    questionCode: question?.code ?? null,
                    questionVersion: question?.version ?? null,
                    answerCode: answers?.[index]?.code ?? null,
                    answerVersion: answers?.[index]?.version ?? null,
                    userInput: null,
                });
            })
        });
        this.handleSubmit.emit(payload);
    }
}
